import { render, staticRenderFns } from "./ClientNewDetails.vue?vue&type=template&id=1483d88f&scoped=true&"
import script from "./ClientNewDetails.vue?vue&type=script&lang=js&"
export * from "./ClientNewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483d88f",
  null
  
)

export default component.exports